// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"832":"f1fb34bb","6549":"9a5db1f5"}[chunkId] + ".chunk.css";
};